<kodit-table
  *ngIf="uplateTable.length > 0"
  [tableConfig]="tableConfig"
  [items]="uplateTable"
>
</kodit-table>
